/* RESPONSIBLE TEAM: team-phone */
import HangUpSerializer from '../step';

export default HangUpSerializer;
